import { render, staticRenderFns } from "./dialog-contract-filing.vue?vue&type=template&id=2faf33f7&scoped=true&"
import script from "./dialog-contract-filing.vue?vue&type=script&lang=js&"
export * from "./dialog-contract-filing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2faf33f7",
  null
  
)

export default component.exports